module.exports = __webpack_public_path__ + "static/img/logo_white.ecfce6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo_white.png
// module id = a9/k
// module chunks = 1